var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3111 1.31744C12.2397 1.17289 12.1255 1.05047 11.982 0.964661C11.8385 0.878853 11.6718 0.833252 11.5014 0.833252C11.3311 0.833252 11.1643 0.878853 11.0208 0.964661C10.8773 1.05047 10.7631 1.17289 10.6918 1.31744L8.13266 6.50078L2.06837 7.17328C1.89917 7.19195 1.73924 7.25553 1.60751 7.35649C1.47577 7.45746 1.37774 7.59158 1.32502 7.74299C1.2723 7.8944 1.26709 8.05675 1.31002 8.21084C1.35295 8.36492 1.44221 8.50429 1.56725 8.61244L6.05238 12.4874L4.86199 18.0874C4.82893 18.2435 4.84438 18.4052 4.90653 18.5534C4.96867 18.7015 5.07491 18.83 5.21268 18.9235C5.35044 19.017 5.51398 19.0717 5.68396 19.0811C5.85394 19.0905 6.02324 19.0543 6.17186 18.9766L11.5014 16.1883L16.831 18.9766C16.9797 19.0546 17.1492 19.0911 17.3194 19.0818C17.4897 19.0725 17.6535 19.0177 17.7914 18.9241C17.9294 18.8304 18.0357 18.7017 18.0978 18.5533C18.1599 18.4048 18.1751 18.2429 18.1417 18.0866L16.9513 12.4883L21.4356 8.61244C21.5606 8.50429 21.6499 8.36492 21.6928 8.21084C21.7357 8.05675 21.7305 7.8944 21.6778 7.74299C21.6251 7.59158 21.5271 7.45746 21.3953 7.35649C21.2636 7.25553 21.1037 7.19195 20.9345 7.17328L14.8693 6.49994L12.3111 1.31744Z",
    fill: "#FFBA53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c70778c31a96735b69d12864de6cee06.svg";
export { ForwardRef as ReactComponent };